import axios from 'axios'
import { injectBaseParams } from './interceptors/request/injectBaseParams'
import { decamelizeKeysInterceptor } from './interceptors/request/decamelizeKeysInterceptor'
import { camelizeKeysInterceptor } from './interceptors/response/camelizeKeysInterceptor'
import { responseErrorInterceptor } from './interceptors/response/responseErrorInterceptor'

const client = axios.create({
  timeout: 0, // Set to 0 for now since we have slow betty api requests.
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
})

client.interceptors.request.use(injectBaseParams)
client.interceptors.request.use(decamelizeKeysInterceptor)

client.interceptors.response.use(
  camelizeKeysInterceptor,
  responseErrorInterceptor
)

export default client
